import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { OperationsReviewListState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { IState } from "../..";
import { OperationsReviewWorkItemRequest } from "../../../app/data/shipment-reconciliation/models";

const initialState: OperationsReviewListState = {
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestFailStatus: 0,
  requestError: "",
  hasNext: true,
  nextCursor: 0,
  shipmentWorkItems: []
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const getOperationsReviewListSlice = createSlice({
  name: "getOperationsReviewListSlice",
  initialState,
  reducers: {
    resetList: () => initialState,
    requestStarted: (state, { payload }) => {
      if (payload.requestCreator === "GET_OPERATIONS_REVIEW_LIST_PORTION") {
        state.fetchPortionStarted = true;
      } else {
        state.requestStarted = true;
      }
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestCreator = payload;
      state.requestError = "";
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = true;
      state.requestFailed = false;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestFailStatus = payload.status;
      state.requestError = payload.error;
    },
    setOperationsReviewList: (state, { payload }) => {
      state.shipmentWorkItems = payload.shipmentWorkItems;
      state.nextCursor = (payload.nextCursor) ? payload.nextCursor : null;
      state.hasNext = (payload.nextCursor) ? true : false;
    },
    addOperationsReviewList: (state, { payload }) => {
      state.shipmentWorkItems = [...state.shipmentWorkItems, ...payload.shipmentWorkItems];
      state.nextCursor = (payload.nextCursor) ? payload.nextCursor : null;
      state.hasNext = (payload.nextCursor) ? true : false;
    },
    changeOperationsReviewListLocally: (state, { payload }) => {
      if (payload.shipmentWorkItems) state.shipmentWorkItems = payload.shipmentWorkItems;
    },
  },
});

export const {
  resetList,
  requestStarted,
  requestSucceed,
  requestFailed,
  setOperationsReviewList,
  addOperationsReviewList,
  changeOperationsReviewListLocally
} = getOperationsReviewListSlice.actions;

export const getOperationsReviewListSelector = (state: IState) => state.operationsReviewList;

export const getOperationsReviewWorkItems = (
  requestData: OperationsReviewWorkItemRequest,
  onError?: (error: string) => void,
): AppThunk => async (dispatch) => {
  if (!requestData || !requestData.terminalNumber) {
    dispatch(requestFailed({
      status: 500,
      error: "Can not get data without assigned terminal"
    }
    ));
    return;
  }
  dispatch(requestStarted({
    requestCreator: requestData.cursor ? "GET_OPERATIONS_REVIEW_LIST_PORTION" : "GET_OPERATIONS_REVIEW_LIST"
  }
  ));
  const response = await shipmentReconciliationService.getOperationsReviewList(requestData);
  if (response.ok() && response.data) {
    dispatch(requestData.cursor ? addOperationsReviewList(response.data) :  setOperationsReviewList(response.data))
    dispatch(requestSucceed());
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(requestFailed({
      status: response.status,
      error
    }));
    onError && onError(error)
  }
};

const getOperationsReviewListReducer = getOperationsReviewListSlice.reducer;
export default getOperationsReviewListReducer;